function _classCallCheck(instance, Constructor) { if (!(instance instanceof Constructor)) { throw new TypeError("Cannot call a class as a function"); } }

var Deferring = function Deferring() {
  _classCallCheck(this, Deferring);

  this.resolve = null;
  this.reject = null;
  this.promise = new Promise(function (resolve, reject) {
    this.resolve = resolve;
    this.reject = reject;
  }.bind(this));
};

export var Deferred = function Deferred() {
  return new Deferring();
};

export var defer = function defer(code) {
  var deferred = new Deferring();
  code(deferred);
  return deferred.promise;
};